<template>
	<div>
		<div style="width: 320px;height: 370px;margin-top: 160px;
			margin-left: auto;margin-right: auto; border-radius: 10px;background-color: #fff;">
			<div style="height: 100px;line-height: 100px;display: flex;justify-content: center;align-items: center;">
				<span >{{ title }}</span>
			</div>	
			<el-form style="padding-left: 40px;padding-right: 40px;">
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-user-solid" autofocus placeholder="请输入账号" v-model="formdata.username"></el-input>
				</el-form-item>
				<el-form-item >
				    <el-input clearable prefix-icon="el-icon-star-on" type="password" :show-password="true" placeholder="请输入新密码" v-model="formdata.userpwd"></el-input>
				</el-form-item>
				<el-form-item >
					<el-row>
						<el-col :span="12">
							 <el-input clearable prefix-icon="el-icon-warning" placeholder="短信验证码" v-model="formdata.smscode"></el-input>
						</el-col>
						<el-col :span="12">
							<el-button type="primary" :disabled="smsdisable" @click="sendSms">{{smsbtnword}}</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item >
				   <el-button style="width: 100%;" type="primary" @click="submitForgot">修改密码</el-button>
				</el-form-item>
			</el-form>
				
		</div>	
		<div style="position: absolute;bottom: 0px;margin-bottom: 20px;color: #7EA8EB;
			text-align: center;width: 99%;font-size: 12px;">
			<div style="">
				Copyright @ 2024-2099 Sinowyde. All Right Reserved.
			</div>
			<div style="">
				@ 2024-2099 版权所有 宇衡金凯 |
			</div>
		</div>
	</div>
</template>

<script>
	//import {userForgetPwd,getSmsCode} from '/static/apiUrl.js'
	export default {
		name : 'ForgotPassword',
		data() {
			return {
				smsbtnword : '发送验证码',
				countdown : 60,
				smsdisable : false,
				//leftlogourl : "@/assets/images/yh-logo-1.png",
				title : '忘记密码',
				formdata : {
					username : '',
					userpwd : '',
					smscode : '',
				},
				
			}
		},
		mounted() {
			console.log('333')
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
		},
		methods: {
			submitForgot(){
				if(this.formdata.username === null || this.formdata.username == ''){
					this.$message({
						showClose: true,
						message: '请输入账号',
						type: 'error'
					});
					return;
				}
				if(this.formdata.userpwd === null || this.formdata.userpwd == ''){
					this.$message({
						showClose: true,
						message: '请输入新密码',
						type: 'error'
					});
					return;
				}
				if(this.formdata.smscode === null || this.formdata.smscode == ''){
					this.$message({
						showClose: true,
						message: '请输入短信验证码',
						type: 'error'
					});
					return;
				}
				//TODO
				this.formdata.userpwd = this.$md5(this.formdata.userpwd)
				/* userForgetPwd({
					username: this.formdata.username,
					userpwd: this.formdata.userpwd,
					smscode: this.formdata.smscode,
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.$message({
							showClose: true,
							message: '修改密码成功',
							type: 'success'
						});
						let pthis = this
						setTimeout(() => {
							pthis.$router.push({ name: 'noAuth401' });
						}, 1500)
					}else{
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error'
						});
					}
				}) */

				this.$router.go(-1);
			},
			sendSms(){
				if(this.formdata.username === null || this.formdata.username == ''){
					this.$message({
						showClose: true,
						message: '请先输入账号',
						type: 'error'
					});
				}else{
					//发送短信验证码
					this.GetSmsCode("forgot")

					this.smsdisable = true
					this.smsbtnword = '60s后重试'
					let pthis = this
					let timeout = setInterval(()=>{
						pthis.countdown--
						if(pthis.countdown == 0){
							clearInterval(timeout)
							pthis.smsdisable = false
							pthis.smsbtnword = '发送验证码'
							pthis.countdown = 60
						}else{
							pthis.smsbtnword = pthis.countdown + 's后重试'
						}
					},1000)
				}
			},
			GetSmsCode(type){
				/* getSmsCode({
					username: this.formdata.username,
					type: type,
				}).then(res => {
					if (0 == res.code) {
						console.log("")
					}
				}) */
			},
		},
		beforeCreate () {
			document.querySelector('body').setAttribute('style', 'background-color:#4E73DF')
		},
		beforeDestroy () {
			document.querySelector('body').setAttribute('style', 'background-color:#FFF')
		},
	}
</script>

<style>
	
</style>